import "./Label_module.css";
const Label_module_rslib_entry_ = {
    label: "label-_M7u63"
};
export { Label_module_rslib_entry_ as default };

//# sourceMappingURL=Label.module.js.map